import { useTranslation } from "hooks/useTranslation";
import Head from "layout/Head";
import React, { Fragment } from "react";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import { SwitchingValue } from "constants/modelCompareData/data/SwitchingValue";
import { PhysicalSecurityOverview } from "constants/modelCompareData/data/PhysicalSecurityOverview";
import { WifiFlagship } from "constants/modelCompareData/data/WifiFlagship";
import { ExtendedTabId } from "components/ExtendedTabs/ExtendedTabs.types";
import { HowItWorksPage } from "components/HowItWorksPage";
import {
  DEPLOYMENT_HERO_CONFIG,
  RACK_DEPLOYMENT_MOBILE_CONFIG,
  RACK_DEPLOYMENT_SWITCHING_TAB,
} from "./RackMounted.config";
import { MODEL_COMPARE_TABS } from "../shared.config";

import simpleRackMountedDeploymentRiv from "../assets/rive/simple-rack-mounted-deployment.riv";
import simpleRackMountedDeploymentMobileRiv from "../assets/rive/simple-rack-mounted-deployment-mobile.riv";

const MODEL_COMPARE_DATA_BY_ID = {
  [ModelCompareTab.Switching]: SwitchingValue,
  [ModelCompareTab.AccessPoints]: WifiFlagship,
  [ModelCompareTab.Cameras]: PhysicalSecurityOverview,
  [ModelCompareTab.DoorAccess]: null,
};

export const RackMountedDeployment = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("gettingStartedWithUniFi.seo.title")}
        description={t("gettingStartedWithUniFi.seo.description")}
        url="https://ui.com/how-it-works/large"
        image="https://www.ui.com/microsite/og-image.png"
      />

      <HowItWorksPage
        hero={{
          title: "gettingStartedWithUniFi.hero.title",
          config: DEPLOYMENT_HERO_CONFIG,
          mobileConfig: RACK_DEPLOYMENT_MOBILE_CONFIG,
        }}
        topology={{
          title: "gettingStartedWithUniFi.topology.intro.title",
          description: "gettingStartedWithUniFi.topology.intro.description",
          config: {
            src: simpleRackMountedDeploymentRiv,
          },
          mobileConfig: {
            src: simpleRackMountedDeploymentMobileRiv,
          },
        }}
        activePageId={ExtendedTabId.LargeDeployment}
        compareTabs={[RACK_DEPLOYMENT_SWITCHING_TAB, ...MODEL_COMPARE_TABS]}
        compareOptions={MODEL_COMPARE_DATA_BY_ID}
      />
    </Fragment>
  );
};
